import { WidgetType } from '../../enums'
import { WidgetData } from '../../types'
import { getAiTeammateWidgetService } from './aiTeammateWidgetService'
import { getGenericAiWidgetService } from './genericAiWidgetService'

/**
 * Base interface for all widget services -
 * objects providing general operations that can be done
 * with Action Card widgets */
export interface WidgetService {}

/**
 * Factory function to create a widget service for a given widget
 * @param widget The widget data
 * @returns The Widget Service instance
 * @story User Story 10482: Generic Prompt AI widget: select output mode: add or replace
 */
export function getWidgetService(widget: WidgetData): WidgetService | null {
  switch (widget?.type) {
    case WidgetType.GenericAiPrompt:
      return getGenericAiWidgetService(widget)
    case WidgetType.AiTeammate:
      return getAiTeammateWidgetService(widget)
    default:
      return null
  }
}
